import React, { Component } from "react";
import { Panel, Row, Col, Button, FormGroup, FormControl } from "react-bootstrap";

export default class Filter extends Component {
    render() {
        const panelTitle = (
            <h4>
                Filter {(this.props.group || "members")}
                <span onClick={this.props.clearFilters}>Clear filters</span>
            </h4>
        );

        return (
            <Panel className="filter-panel" header={panelTitle} collapsible expanded={this.props.open} onClick={this.props.handlePanelClick}>
                <Row className="search-input-row">
                {this.props.group === undefined &&
                    <div>
                        <h4 className="section-title">Search</h4>
                        <Row className="search-input-row">
                            <label className="search-input">
                                <input className="search-input" onChange={this.props.handleSearchInput} type="text" placeholder="Search members" value={this.props.searchQuery} />
                            </label>
                        </Row>
                    </div>
                }
                </Row>
                <h4 className="section-title">Innovation areas</h4>
                <Row>
                {this.props.innovationAreas.map((area, i) => {
                    return (
                        <Col md={4} key={`filterOption${i + 1}`}>
                            <Button className={`filter-option${this.props.activeFilters.innovations.includes(area.id.toString()) ? " active" : ""}`} onClick={this.props.handleOptionClick} data-innovation-id={area.id}>{area.name}</Button>
                        </Col>
                    );
                })}
                </Row>
                <Row className="include-private-sector-row" key={`private-sector-${this.props.includePrivateSector}`}>
                    <Col className="input-wrapper" md={4} mdOffset={8}>
                    <label className="corporate-input">
                        <input className="corporate-input" onChange={this.props.privateSectorClick} type="checkbox" checked={this.props.includePrivateSector} value="private" />
                        Include private sector
                    </label>
                    </Col>
                </Row>
                {this.props.group === undefined && <h4 className="section-title">Country</h4>}
                <Row>
                {this.props.group === undefined && this.props.countries.map(country => (
                    country[0] !== null &&
                    <Col md={4} key={country[0]}>
                        <Button className={`filter-option${this.props.activeFilters.countries.includes(country[0]) ? " active" : ""}`} onClick={this.props.handleOptionClick} data-country={country[0]}>{country[0]}</Button>
                    </Col>
                ))}
                </Row>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/Filter.jsx.erb